<template id="app">
    <v-card class="overflow-hidden v-card v-sheet theme--light mt-0">
      <div>
        <v-alert
          :type="alert_type"
          :value="alert"
          :model-value="alert"
          transition="scale-transition"
          >{{ alert_message }}</v-alert
        >
      </div>
      <header-component :headerTitle="headerText" />
      <!-- seacrh, action button and filter -->
      <!-- <v-card-title class="action-style pb-0">
        <v-row class="ma-3 mb-0">
          <v-text-field  prepend-inner-icon="mdi-magnify" v-model="search_tag" label="Search" style="max-width: 270px;" variant="outlined"></v-text-field>
        </v-row>
      </v-card-title> -->
       <v-list class="notification-list">
        <v-list-item
          v-for="(notification,index) in notifications"
          :key="notification.id"
          class="notification-item"
        >
          <v-list-item-content>
            <v-row class="pt-4 pb-2">
              <v-col cols="7" class="text-left pb-0 pt-4" :class="index !== 0 ? 'top_border' : ''">
              <template v-if="notification.message.length > 100 && screen_width < 1800">
              <!-- Show tooltip if message is more than 50 characters -->
              <v-tooltip location="bottom">
                <template v-slot:activator="{ props }">
                  <v-list-item-title v-bind="props">
                    {{ notification.message.substring(0, 100) + '...' }}
                    <v-divider class="mb-0"></v-divider>
                  </v-list-item-title>
                </template>
                <span>{{ notification.message }}</span>
              </v-tooltip>
            </template>

            <template v-else>
              <!-- Show full message without tooltip if it's 50 characters or less -->
              <v-list-item-title>
                {{ notification.message }}
                <v-divider class="mb-0"></v-divider>
              </v-list-item-title>
            </template>
            </v-col>
              <v-col cols="3" class="text-right pb-0 pt-4">
                <v-list-item-subtitle class="notification-time">{{ notification.time }} <v-icon color="error" style="font-size:10px" class="ml-5"> mdi-circle</v-icon></v-list-item-subtitle>
              </v-col>
            </v-row>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-card>
  </template>
  <script>
  import HeaderComponent from "@/components/commoncomponents/HeaderComponent";
  export default {
    components: {
      HeaderComponent
    },
    data() {
      return {
        headerText: "Notification",
        alert: false,
        alert_type: "success",
        alert_message: "",
        search_tag: "",
        loading: false,
        notifications: [],
        screen_width:''
      };
    },
    created(){
      this.fetchNotifications()
    },
     mounted() {
        window.addEventListener("resize", this.updateWidth);
      },
      beforeUnmount() {
        window.removeEventListener("resize", this.updateWidth);
      },
    methods: {
      updateWidth() {
      this.screen_width = window.innerWidth;
    },
      showAlert(alert_type, alert_message) {
          this.alert = true;
          this.alert_type = alert_type;
          this.alert_message = alert_message;
          this.scrollToTop();
          this.alertTimeOut();
        },
        alertTimeOut() {
          setTimeout(() => {
              this.alert = false;
          }, 3000);
        },
        scrollToTop() {
          window.scrollTo({
            top: 0,
            behavior: 'smooth',
          });
        },
        fetchNotifications() {
          this.$httpSecured
          .get("/api/v2/item_notifications/get_item_notifications")
          .then(response => {
            this.notifications = response.data.data
          })
          .catch(error => {
            this.$toast.error(error.response.data.error)
          });
        }
    }
  };
  </script>
  <style scoped>
  .notification-list {
    max-height: calc(var(--vh, 1vh) * 100 - 82px) !important;
     overflow-y: auto;
  }
  .top_border{
    border-top: 1px solid grey;
  }
  </style>